import { Avatar, Button, Flex, Table, Text } from "@mantine/core";
import config from "config";
import dayjs from "dayjs";
import { Sports } from "modules/news/types";
import { sportTypeConverter } from "utils/sportTypeConverter";

const elements = [
  { position: 6, symbol: "C", name: "Carbon" },
  { position: 7, symbol: "N", name: "Nitrogen" },
  { position: 39, symbol: "Y", name: "Yttrium" },
  { position: 56, symbol: "Ba", name: "Barium" },
  { position: 58, symbol: "Ce", name: "Cerium" },
];

interface Props {
  sports: Sports[] | undefined;
  handleEdit: (id: number) => void;
  handleDelete: (id: number) => void;
}

const TableArticles = (props: any) => {
  const { sports, handleEdit, handleDelete } = props;

  const rows = sports?.map((element: any) => (
    <Table.Tr key={element.id}>
      <Table.Td>
        <Text className="truncate w-[150px] overflow-hidden">
          {element.orderNumber}
        </Text>
      </Table.Td>
      <Table.Td>{element.categoryName}</Table.Td>
      <Table.Td>
        <Text className="truncate w-[120px] overflow-hidden">
          {element.name}
        </Text>
      </Table.Td>

      <Table.Td>{dayjs(element.releaseDate).format("DD-MM-YYYY")}</Table.Td>
      <Table.Td>
        <Flex justify={"end"}>
          <Button
            mr={10}
            variant="light"
            onClick={() => handleEdit(element.id)}
          >
            Tahrirlash
          </Button>
          <Button
            variant="light"
            color="red"
            onClick={() => handleDelete(element.id)}
          >
            O'chirish
          </Button>
        </Flex>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Table
      withColumnBorders
      horizontalSpacing={"md"}
      striped
      highlightOnHover
      withTableBorder
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={10}>Tartib raqami</Table.Th>
          <Table.Th>Kategoriya nomi</Table.Th>
          <Table.Th>Loyiha nomi</Table.Th>

          <Table.Th>Ishlab chiqilgan sana</Table.Th>
          <Table.Th className="text-center" w={100} />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
  );
};

export default TableArticles;
